export class Yield {
    static highYieldChallenge(prebid, amazon, slotName = 'noName') {
        const values = [prebid, amazon].filter(v => typeof v === 'string' && v !== '');
        let value = 'empty';
        if (values.every(v => v === 'no'))
            value = 'no';
        else
            value = values.find(v => v !== 'no') || 'no';
        console.log(`[YIELD-ANAL] |${slotName}| -> prebidjs: ${prebid} vs amazon: ${amazon} = ${value}`);
        return value;
    }
}
